export default __webpack_public_path__ + "static/media/NAPA AAG 2022 Launch Brochure-FR-20201217-online.d8eec3da.pdf";